module.exports = {
  1: 18313791,
  5: 9837112,
  30: 5709912,
  31: 4368363,
  40: 305712429,
  41: 262212659,
  56: 32456461,
  97: 34057600,
  137: 48518130,
  8453: 5045089,
  17000: 731427,
  42161: 139083280,
  43113: 26625835,
  43114: 36240486,
  59140: 1688893,
  59144: 596975,
  80001: 41015777,
  421613: 46573543,
  11155111: 4508874,
  245022926: 308591477,
}
